import { setChartSettingsTableSettingsAction } from '../../../redux/slices/analyses';
import { useAppDispatch } from '../../../redux/hooks';
import { Order } from '../../../utils/apollo/graphqlSchema';
import { useChartContext } from '../../Chart/ChartContext';
import { TableSortType } from '../../Chart/interfaces';

export default (analysisId: string) => {
  const dispatch = useAppDispatch();
  const {
    settings: { chartSettings },
  } = useChartContext();
  const { sortColumnIndex, sortDirection, sortType } =
    chartSettings.tableSettings;

  const onChangeSort = (
    index: number | null,
    direction: Order,
    sortType?: TableSortType,
  ) => {
    dispatch(
      setChartSettingsTableSettingsAction({
        analysisId,
        tableSettings: {
          sortColumnIndex: index,
          sortDirection: direction,
          sortType,
        },
      }),
    );
  };

  const onSort = ({
    index,
    sortOrder,
    sortType,
  }: {
    index: number | null;
    sortOrder?: Order;
    sortType?: TableSortType;
  }) => {
    if (sortOrder) {
      onChangeSort(index, sortOrder, sortType);
    } else {
      onChangeSort(
        index,
        sortDirection === Order.Asc ? Order.Desc : Order.Asc,
        sortType,
      );
    }
  };

  const updateSortIndex = (index: number) => {
    dispatch(
      setChartSettingsTableSettingsAction({
        analysisId,
        tableSettings: {
          sortColumnIndex: index,
        },
      }),
    );
  };

  const resetSortState = () => {
    dispatch(
      setChartSettingsTableSettingsAction({
        analysisId,
        tableSettings: {
          sortColumnIndex: undefined,
          sortDirection: undefined,
          sortType: undefined,
        },
      }),
    );
  };

  return {
    sortColumnIndex,
    sortDirection,
    sortType,
    onSort,
    updateSortIndex,
    resetSortState,
  };
};
